'use strict';

angular.module('mean.bids').factory('bidService', ['$q', 'Bids', 'GeneralTasks', 'Subtasks', 'Projects', 'ProjectJobs', 'taskTotalsService', 'tradeCodeService', 'Builders', '$filter', 'ProjectBids', 'Trades', 'toaster', 'TradeBids', 'optionSaveService',
    function($q, Bids, GeneralTasks, Subtasks, Projects, ProjectJobs, taskTotalsService, tradeCodeService, Builders, $filter, ProjectBids, Trades, toaster, TradeBids, optionSaveService) {
        
        var attachTaskList = function(bid, subtasks, type, location, trade, isCustom = false, userIds = '') {
            var deferred = $q.defer();

            GeneralTasks.query({ 
                'projectType': type, 
                'geoLocation': location, 
                'trade': trade,
                'isCustom': isCustom,
                'userId': userIds
            }, function(tasks) {

                tasks.sort(function(a, b){
                    return a.order - b.order;
                });

                tasks.forEach(function(task, index){
                    var inlist = $filter('filter')(bid.task_list, {'trade': task.trade, 'task': task.task}, true);

                    if(inlist.length == 0) {
                        bid.task_list.push({
                            _id: task.order,
                            trade: task.trade,
                            task: task.task,
                            name: task.task_name,
                            subtasks: []
                        });
                    } else {
                        console.log('skipping ' + task.trade + task.task + ' because its already there.');
                    }

                    // var subtask_index = 0;

                    // subtasks = $filter('orderBy')(subtasks, 'subtask_name');

                    // subtasks.forEach(function(subtask, j) {
                    //     if(task.task_code === subtask.subtask_code) {
                    //         bid.task_list[index].subtasks.push({
                    //             _id: subtask_index,
                    //             subtask_id: subtask._id,
                    //             code: subtask.subtask_code,
                    //             trade: subtask.subtask_trade,
                    //             task: subtask.subtask,
                    //             name: subtask.subtask_name,
                    //             unit: subtask.unit.unit,
                    //             piece_rate: subtask.piece_rate,
                    //             crew_rate: subtask.crew_rate,
                    //             piece_per_hour_rate: subtask.piece_per_hour_rate
                    //         });

                    //         subtask_index = subtask_index + 1;
                    //     }
                    // });
                });

                deferred.resolve(bid);
            });

            return deferred.promise;
        };

        var padDigits = function(number, digits) {
            return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
        }

        var acceptBid = function(mainAccountId, bid, trade_code, builder, totals) {
            var bid_trades = [];
            var plan_codes = [];
            var tasks = [];
            var plans = [];

            console.log('in bid-service acceptBid');

            var menu = bid.project_plan;

            _.each(bid.plan_codes, function(plan) {
                var code = plan.code;
                var trade_totals = [];
                var total = 0;

                var items = $filter('filter')(totals, {'plan': code}, true);

                _.each(items, function(item) {
                    trade_totals.push({
                        trade: item.trade,
                        total: item.total,
                        revision: 1
                    });

                    total += item.total;
                });

                plan_codes.push({
                    item: code,
                    trade_totals: trade_totals,
                    total: total
                });
            });

            bid.bidding_trades.forEach(function(bidder, idx) {
                if(builder && !bidder.accepted) return;

                bid_trades.push({
                    name: bidder.trade,
                    main_username: bidder.username,
                    manager: {
                        name: bidder.name,
                        username: bidder.username,
                        phone: bidder.phone,
                        email: bidder.email
                    },
                    supplier: bidder.supplier,
                    equipment_supplier: bidder.equipment_supplier,
                    inclusions: bidder.inclusions,
                    exclusions: bidder.exclusions,
                    company_factors: {
                        payroll_taxes: bidder.costs.payroll_taxes,
                        w_comp_high: bidder.costs.w_comp_high,
                        w_comp_low: bidder.costs.w_comp_low,
                        general_liability: bidder.costs.general_liability,
                        w_comp_break: bidder.costs.w_comp_break,
                        sales_tax: bidder.costs.sales_tax,
                        material: bidder.costs.material,
                        equipment: bidder.costs.equipment,
                        labor: bidder.costs.labor
                    }
                });

                tasks = [];
                var days_off = 0;
                bidder.task_list.forEach(function(task, ii) {
                    var subs = [];
                    task.subtasks.forEach(function(sub) {
                        subs.push({
                            name: sub.name
                        });
                    });

                    tasks.push({
                        name: task.name,
                        order: task._id,
                        task: task.task,
                        hours: 8.0,
                        days: 1.0,
                        days_offset: days_off,
                        trade: task.trade,
                        subtasks: subs
                    });

                    days_off += 1;
                });

                plans.push({
                    item: 'Standard',
                    task_list: tasks
                });
            });

            if(builder) {
                var query = bid.builder_id._id ? bid.builder_id._id : bid.builder_id;
                Builders.query({'_id': query}, function(builder) {
                    if(builder.length !== 1) {
                        alert('Problem getting builder info.  Contact admin');
                        return;
                    }

                    ProjectJobs.query({'company_code': padDigits(builder[0].company_code, 3),
                        'trade_code': trade_code}, function(jobs) {
                        var new_job_code = '';

                        if(jobs.length === 1) {
                            new_job_code = padDigits(jobs[0].current_value, 4);
                            jobs[0].current_value = jobs[0].current_value + 1;
                            if(jobs[0].current_value === 10000) jobs[0].current_value = 1;
                            jobs[0].$update();
                        } else if(jobs.length === 0) {
                            var new_job = new ProjectJobs({
                                company_code: padDigits(builder[0].company_code, 3),
                                trade_code: trade_code,
                                current_value: 2
                            });
                            new_job_code = padDigits(1, 4);
                            new_job.$save();
                        } else if(jobs.length > 1) {
                            alert('More than one contractor/division combination came back.  Call admin.');
                            return;
                        }

                        var pa = {
                            name: '',
                            email: '',
                            phone: ''
                        }

                        if(bid.purchasing_agent_info) {
                            pa = bid.purchasing_agent_info;
                        } else {
                            pa.name = bid.purchasing_agent_name;
                            pa.email = bid.purchasing_agent_email;
                            pa.phone = bid.purchasing_agent_phone;
                        }

                        var bid_builder = {
                            name: '',
                            address_one: '',
                            address_two: '',
                            city: '',
                            state: '',
                            zip: '',
                            email: '',
                            phone: ''
                        }

                        if(bid.builder_info) {
                            bid_builder = bid.builder_info;
                        } else {
                            bid_builder = builder[0];
                        }

                        var project = new Projects({
                            name: bid.project_name,
                            projectBidId: bid._id,
                            job_code: new_job_code,
                            trade_code: trade_code,
                            company_code: padDigits(builder[0].builder.contractor_code, 3),
                            contact: {
                                name: pa.name,
                                address_one: bid.project_address,
                                address_two: '',
                                city: bid.project_city,
                                state: bid.project_state,
                                zip: bid.project_zip,
                                timezone: bid.project_timezone,
                                email: pa.email,
                                phone: pa.phone
                            },
                            builder: {
                                name: bid_builder.name,
                                address_one: bid_builder.address_one,
                                address_two: bid_builder.address_two,
                                city: bid_builder.city,
                                state: bid_builder.state,
                                zip: bid_builder.zip,
                                email: bid_builder.email,
                                phone: bid_builder.phone
                            },
                            mtc: {
                                name: bid.mtc_name,
                                code: bid.mtc_code,
                                division: bid.mtc_division,
                                president_name: bid.mtc_president_name,
                                president_phone_number: bid.mtc_president_phone_number,
                                president_email: bid.mtc_president_email,
                                division_manager_name: bid.mtc_division_manager_name,
                                division_manager_phone_number: bid.mtc_division_manager_phone_number,
                                division_manager_email: bid.mtc_division_manager_email
                            },
                            //options: bid.options,
                            project_type: bid.project_type,
                            projectType: bid.projectType,
                            geoLocation: bid.geoLocation,
                            plan_codes: plan_codes,
                            trades: bid_trades,
                            plan: plans,
                            mainAccountId: mainAccountId
                        });

                        project.$save(function(saved) {

                            console.log('project save came back with ' + saved._id);
                            if(optionSaveService.updateProjectIdFromBidId(bid._id, saved._id)) {
                                return;
                            }

                            _.each(bid.bidding_trades, function(bidder) {
                                //var trade = $filter('filter')(company_factors, {trade_name: bidder.trade}, true)[0];
                                if(bidder.accepted === true) {
                                    // Options.query({'tradebid_id': bidder._id}, function(options) {
                                    //     options.forEach(function(opt) {
                                    //         opt.project_id = saved._id;
                                    //         opt.$update();
                                    //     });
                                    // });

                                    _.each(saved.plan_codes, function(plan) {
                                        var tasks = $filter('filter')(bidder.bid, {plan_code: plan.item}, true);

                                        var project_bids = [];
                                        _.each(tasks, function(task) {
                                            var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true);
                                            if(cp_task.length !== 1)
                                                alert('There is an issue getting the task');

                                            _.each(task.subtasks, function(sub, ij) {
                                                sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
                                                sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
                                                sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
                                                sub.unit = cp_task[0].subtasks[ij].unit;

                                                _.each(sub.materials, function(mat, jj) {
                                                    mat.supplier = cp_task[0].subtasks[ij].materials[jj].supplier;
                                                });

                                                _.each(sub.equipment, function(eq, jj) {
                                                    eq.supplier = cp_task[0].subtasks[ij].equipment[jj].supplier;
                                                });
                                            });
                                        });
                                        //before applying the calcs, get the piece rates and stuff from the task list
                                        //$scope.applayCalculations(tasks);
                                        taskTotalsService.getCalculations(tasks, bidder.costs);

                                        //now we have all the calculations for a given plan, so lets save them
                                        //off into the projectBids database
                                        _.each(tasks, function(task, itr) {
                                            var cp_task = $filter('filter')(bidder.task_list, {
                                                _id: task.task_id}, true)[0];
                                            if(!cp_task) {
                                                alert('Could not get the task from the bid.task_list.  Call admin.');
                                                return;
                                            }
                                            var sub_arr = [];
                                            var mat_arr = [];
                                            var eq_arr = [];

                                            //build the subtask array
                                            _.each(task.subtasks, function(sub, i) {
                                                sub_arr.push({
                                                    task_id: sub.task_id,
                                                    name: cp_task.subtasks[i].name,
                                                    crew_rate: sub.crew_rate,
                                                    current_net_pay: sub.current_net_pay,
                                                    employee_benefits: sub.employee_benefits,
                                                    piece_per_hour_rate: sub.piece_per_hour_rate,
                                                    piece_rate: sub.piece_rate,
                                                    unit: sub.unit,
                                                    bid_hours: sub.bid_hours,
                                                    hours_allowed: sub.hours_allowed,
                                                    training_and_education: sub.training_and_education,
                                                    quantity: sub.quantity,
                                                    labor_total: sub.labor,
                                                    bid_mark_up: sub.bid_mark_up,
                                                    general_liability: sub.general_liability,
                                                    material_total: sub.material_total,
                                                    materials_subtotal: sub.materials_subtotal,
                                                    materials_dev_subtotal: sub.materials_dev_subtotal,
                                                    equipment_total: sub.equipment_total,
                                                    equipment_subtotal: sub.equipment_subtotal,
                                                    equipment_dev_subtotal: sub.equipment_dev_subtotal,
                                                    total: sub.total,
                                                    work_comp: sub.work_comp
                                                });

                                                _.each(sub.materials, function(mat, j) {
                                                    mat_arr.push({
                                                        name: cp_task.subtasks[i].materials[j].name,
                                                        material_id: mat.material_id,
                                                        materials_subtotal: mat.materials_subtotal,
                                                        materials_dev_subtotal: mat.materials_dev_subtotal,
                                                        supplier: mat.supplier,
                                                        quantity: mat.quantity,
                                                        price_per_order: mat.price_per_order,
                                                        piece_per_size: mat.piece_per_size,
                                                        delivery_price: mat.delivery_price,
                                                        isInventory: mat.isInventory || false,
                                                        delivery_offset: cp_task.subtasks[i].materials[j].delivery_offset,
                                                        description: cp_task.subtasks[i].materials[j].description,
                                                        note: cp_task.subtasks[i].materials[j].note,
                                                        unit: cp_task.subtasks[i].materials[j].unit
                                                    });
                                                });

                                                _.each(sub.equipment, function(eq, j) {
                                                    eq_arr.push({
                                                        name: cp_task.subtasks[i].equipment[j].name,
                                                        equipment_id: eq.equipment_id,
                                                        equipment_subtotal: eq.equipment_subtotal,
                                                        equipment_dev_subtotal: eq.equipment_dev_subtotal,
                                                        supplier: eq.supplier,
                                                        quantity: eq.quantity,
                                                        price_per_order: eq.price_per_order,
                                                        piece_per_size: eq.piece_per_size,
                                                        delivery_price: eq.delivery_price,
                                                        delivery_offset: cp_task.subtasks[i].equipment[j].delivery_offset,
                                                        description: cp_task.subtasks[i].equipment[j].description,
                                                        note: cp_task.subtasks[i].equipment[j].note,
                                                        unit: cp_task.subtasks[i].equipment[j].unit
                                                    });
                                                });
                                            });

                                            var override = $filter('filter')(bidder.overrides, {
                                                'plan_code': task.plan_code, 'enabled': true }, true);

                                            var offset_total = 0;
                                            var mark_up = task.bid_mark_up
                                            //only adjust override total on the first task
                                            if(override.length === 1 && itr === 0) {
                                                offset_total = override[0].amount - override[0].original_amount;
                                                mark_up = override[0].amount;
                                            }

                                            var extra_liability = $filter('filter')(bidder.extra_liability, {
                                                'plan_code': task.plan_code, 'enabled': true }, true);

                                            if(extra_liability.length === 1 && itr === 0) {
                                                task.bid_general_liability += extra_liability[0].amount;
                                                task.total += extra_liability[0].amount;
                                            }

                                            var proBid = new ProjectBids({
                                                task_name: cp_task.name,
                                                trade: tradeCodeService.getName(cp_task.trade),
                                                project_id: saved._id,
                                                task_code: cp_task.trade + cp_task.task,
                                                plan_code: task.plan_code,
                                                days: 1.0,
                                                hours: 8.0,
                                                days_offset: task.task_id - 1,
                                                task_id: task.task_id,
                                                totals: {  //task totals computed during bid phase (during accepting)
                                                    total: task.total + offset_total,
                                                    labor: task.total_labor,
                                                    materials: task.total_materials,
                                                    materials_subtotal: task.materials_subtotal,
                                                    materials_dev_subtotal: task.materials_dev_subtotal,
                                                    equipment: task.total_equipment,
                                                    equipment_subtotal: task.equipment_subtotal,
                                                    equipment_dev_subtotal: task.equipment_dev_subtotal,
                                                    current_net_pay: task.total_current_net_pay,
                                                    general_liability: task.bid_general_liability,
                                                    mark_up: mark_up,
                                                    work_comp: task.work_comp,
                                                    hours_allowed: task.total_hours_allowed
                                                },
                                                subtasks: sub_arr,
                                                materials: mat_arr,
                                                equipment: eq_arr
                                            });

                                            project_bids.push(proBid);
                                        });

                                        ProjectBids.bulkAdd(project_bids, function(results) {
                                            if(results[0])
                                              toaster.pop('success',
                                                'Project Bids Created',
                                                'Plan data ' + results[0].plan_code + ' saved to database');
                                        });
                                    });
                                }
                            });

                            bid.project_id = saved._id;
                            bid.bid_status = 'project';
                            bid.$update();
                        });
                    });
                });
            } else {
                var query = bid.trade_id._id ? bid.trade_id._id : bid.trade_id;

                Trades.query({'_id': query}, function(builder) {
                    if(builder.length !== 1) {
                        alert('Problem getting builder info.  Contact admin');
                        return;
                    }

                    console.log(builder[0].company_code);

                    ProjectJobs.query({'company_code': padDigits(builder[0].company_code, 3),
                        'trade_code': trade_code}, function(jobs) {
                        var new_job_code = '';

                        if(jobs.length === 1) {
                            new_job_code = padDigits(jobs[0].current_value, 4);
                            jobs[0].current_value = jobs[0].current_value + 1;
                            if(jobs[0].current_value === 10000) jobs[0].current_value = 1;
                            jobs[0].$update();
                        } else if(jobs.length === 0) {
                            var new_job = new ProjectJobs({
                                company_code: padDigits(builder[0].company_code, 3),
                                trade_code: trade_code,
                                current_value: 2
                            });
                            new_job_code = padDigits(1, 4);
                            new_job.$save();
                        } else if(jobs.length > 1) {
                            alert('More than one contractor/division combination came back.  Call admin.');
                            return;
                        }

                        var pa = {
                            name: '',
                            email: '',
                            phone: ''
                        }

                        if(bid.purchasing_agent_info) {
                            pa = bid.purchasing_agent_info;
                        } else {
                            pa.name = bid.purchasing_agent_name;
                            pa.email = bid.purchasing_agent_email;
                            pa.phone = bid.purchasing_agent_phone;
                        }

                        var bid_builder = {
                            name: '',
                            address_one: '',
                            address_two: '',
                            city: '',
                            state: '',
                            zip: '',
                            email: '',
                            phone: ''
                        }

                        if(bid.builder_info) {
                            bid_builder = bid.builder_info;
                        } else {
                            bid_builder = builder[0];
                        }

                        var pm = {
                            name: '',
                            email: '',
                            phone: ''
                        }

                        if(bid.project_manager_info) {
                            pm = bid.project_manager_info
                        }

                        var geocoder = new google.maps.Geocoder();
                        var lat = null, lng = null;
                        geocoder.geocode( { 'address' : bid.project_address + " " + bid.city + " " + bid.state }, function( results, status ) {
                            if (status == 'OK') {
                                lat = results[0].geometry.location.lat();
                                lng = results[0].geometry.location.lng();
                            }
                            var project = new Projects({
                                name: bid.project_name,
                                projectBidId: bid._id,
                                job_code: new_job_code,
                                trade_code: trade_code,
                                company_code: padDigits(builder[0].company_code, 3),
                                contact: {
                                    name: pa.name,
                                    address_one: bid.project_address,
                                    address_two: '',
                                    city: bid.project_city,
                                    state: bid.project_state,
                                    zip: bid.project_zip,
                                    timezone: bid.project_timezone,
                                    email: pa.email,
                                    phone: pa.phone,
                                    lat: lat,
                                    lng: lng
                                },
                                builder: {
                                    name: bid_builder.name,
                                    address_one: bid_builder.address_one,
                                    address_two: bid_builder.address_two,
                                    city: bid_builder.city,
                                    state: bid_builder.state,
                                    zip: bid_builder.zip,
                                    email: bid_builder.email,
                                    phone: bid_builder.phone
                                },
                                mtc: {
                                    // name: bid.mtc_name,
                                    // code: bid.mtc_code,
                                    // division: bid.mtc_division,
                                    // president_name: bid.mtc_president_name,
                                    // president_phone_number: bid.mtc_president_phone_number,
                                    // president_email: bid.mtc_president_email,
                                    division_manager_name: pm.name,
                                    division_manager_phone_number: pm.phone,
                                    division_manager_email: pm.email
                                },
                                //options: bid.options,
                                project_type: bid.project_type,
                                projectType: bid.projectType,
                                geoLocation: bid.geoLocation,
                                plan_codes: plan_codes,
                                trades: bid_trades,
                                plan: plans,
                                mainAccountId: mainAccountId
                            });

                            project.$save(function(saved) {

                                console.log('project save came back with ' + saved._id);
                                if(optionSaveService.updateProjectIdFromBidId(bid._id, saved._id)) {
                                    return;
                                }

                                _.each(bid.bidding_trades, function(bidder) {
                                    //var trade = $filter('filter')(company_factors, {trade_name: bidder.trade}, true)[0];
                                    //if(bidder.accepted === true) {
                                    // Options.query({'tradebid_id': bidder._id}, function(options) {
                                    //     options.forEach(function(opt) {
                                    //         opt.project_id = saved._id;
                                    //         opt.$update();
                                    //     });
                                    // });

                                    //saved.plan_codes.forEach(function(plan) {
                                    _.each(saved.plan_codes, function(plan) {
                                        var tasks = $filter('filter')(bidder.bid, {plan_code: plan.item}, true);

                                        var project_bids = [];
                                        _.each(tasks, function(task) {
                                            var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true);
                                            if(cp_task.length !== 1)
                                                alert('There is an issue getting the task');

                                            _.each(task.subtasks, function(sub, ij) {
                                                sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
                                                sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
                                                sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
                                                sub.unit = cp_task[0].subtasks[ij].unit;

                                                _.each(sub.materials, function(mat, jj) {
                                                    mat.supplier = cp_task[0].subtasks[ij].materials[jj].supplier;
                                                });

                                                _.each(sub.equipment, function(eq, jj) {
                                                    eq.supplier = cp_task[0].subtasks[ij].equipment[jj].supplier;
                                                });
                                            });
                                        });
                                        //before applying the calcs, get the piece rates and stuff from the task list
                                        //$scope.applayCalculations(tasks);
                                        taskTotalsService.getCalculations(tasks, bidder.costs);

                                        //now we have all the calculations for a given plan, so lets save them
                                        //off into the projectBids database
                                        //tasks.forEach(function(task) {
                                        _.each(tasks, function(task, itr) {
                                            var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true)[0];
                                            if(!cp_task) {
                                                alert('Could not get the task from the bid.task_list.  Call admin.');
                                                return;
                                            }
                                            var sub_arr = [];
                                            var mat_arr = [];
                                            var eq_arr = [];

                                            //build the subtask array
                                            _.each(task.subtasks, function(sub, i) {
                                                sub_arr.push({
                                                    task_id: sub.task_id,
                                                    name: cp_task.subtasks[i].name,
                                                    crew_rate: sub.crew_rate,
                                                    current_net_pay: sub.current_net_pay,
                                                    employee_benefits: sub.employee_benefits,
                                                    piece_per_hour_rate: sub.piece_per_hour_rate,
                                                    piece_rate: sub.piece_rate,
                                                    unit: sub.unit,
                                                    bid_hours: sub.bid_hours,
                                                    hours_allowed: sub.hours_allowed,
                                                    training_and_education: sub.training_and_education,
                                                    quantity: sub.quantity,
                                                    labor_total: sub.labor,
                                                    bid_mark_up: sub.bid_mark_up,
                                                    general_liability: sub.general_liability,
                                                    material_total: sub.material_total,
                                                    materials_subtotal: sub.materials_subtotal,
                                                    materials_dev_subtotal: sub.materials_dev_subtotal,
                                                    equipment_total: sub.equipment_total,
                                                    equipment_subtotal: sub.equipment_subtotal,
                                                    equipment_dev_subtotal: sub.equipment_dev_subtotal,
                                                    total: sub.total,
                                                    work_comp: sub.work_comp
                                                });

                                                _.each(sub.materials, function(mat, j) {
                                                    mat_arr.push({
                                                        name: cp_task.subtasks[i].materials[j].name,
                                                        material_id: mat.material_id,
                                                        materials_subtotal: mat.materials_subtotal,
                                                        materials_dev_subtotal: mat.materials_dev_subtotal,
                                                        supplier: mat.supplier,
                                                        quantity: mat.quantity,
                                                        price_per_order: mat.price_per_order,
                                                        piece_per_size: mat.piece_per_size,
                                                        delivery_price: mat.delivery_price,
                                                        isInventory: mat.isInventory || false,
                                                        delivery_offset: cp_task.subtasks[i].materials[j].delivery_offset,
                                                        description: cp_task.subtasks[i].materials[j].description,
                                                        note: cp_task.subtasks[i].materials[j].note,
                                                        unit: cp_task.subtasks[i].materials[j].unit
                                                    });
                                                });

                                                _.each(sub.equipment, function(eq, j) {
                                                    eq_arr.push({
                                                        name: cp_task.subtasks[i].equipment[j].name,
                                                        equipment_id: eq.equipment_id,
                                                        equipment_subtotal: eq.equipment_subtotal,
                                                        equipment_dev_subtotal: eq.equipment_dev_subtotal,
                                                        supplier: eq.supplier,
                                                        quantity: eq.quantity,
                                                        price_per_order: eq.price_per_order,
                                                        piece_per_size: eq.piece_per_size,
                                                        delivery_price: eq.delivery_price,
                                                        delivery_offset: cp_task.subtasks[i].equipment[j].delivery_offset,
                                                        note: cp_task.subtasks[i].equipment[j].note,
                                                        unit: cp_task.subtasks[i].equipment[j].unit,
                                                        description: cp_task.subtasks[i].equipment[j].description
                                                    });
                                                });
                                            });

                                            var override = $filter('filter')(bidder.overrides, {
                                                'plan_code': task.plan_code, 'enabled': true }, true);

                                            var offset_total = 0;
                                            var mark_up = task.bid_mark_up
                                            //only adjust override total on the first task
                                            if(override.length === 1 && itr === 0) {
                                                offset_total = override[0].amount - override[0].original_amount;
                                                mark_up = override[0].amount;
                                            }

                                            var extra_liability = $filter('filter')(bidder.extra_liability, {
                                                'plan_code': task.plan_code, 'enabled': true }, true);

                                            if(extra_liability.length === 1 && itr === 0) {
                                                task.bid_general_liability += extra_liability[0].amount;
                                                task.total += extra_liability[0].amount;
                                            }

                                            var proBid = new ProjectBids({
                                                task_name: cp_task.name,
                                                trade: tradeCodeService.getName(cp_task.trade),
                                                project_id: saved._id,
                                                task_code: cp_task.trade + cp_task.task,
                                                plan_code: task.plan_code,
                                                days: 1.0,
                                                hours: 8.0,
                                                days_offset: task.task_id - 1,
                                                task_id: task.task_id,
                                                totals: {  //task totals computed during bid phase (during accepting)
                                                    total: task.total + offset_total,
                                                    labor: task.total_labor,
                                                    materials: task.total_materials,
                                                    materials_subtotal: task.materials_subtotal,
                                                    materials_dev_subtotal: task.materials_dev_subtotal,
                                                    equipment: task.total_equipment,
                                                    equipment_subtotal: task.equipment_subtotal,
                                                    equipment_dev_subtotal: task.equipment_dev_subtotal,
                                                    current_net_pay: task.total_current_net_pay,
                                                    general_liability: task.bid_general_liability,
                                                    mark_up: mark_up,
                                                    work_comp: task.work_comp,
                                                    hours_allowed: task.total_hours_allowed
                                                },
                                                subtasks: sub_arr,
                                                materials: mat_arr,
                                                equipment: eq_arr
                                            });

                                            project_bids.push(proBid);
                                        });

                                        ProjectBids.bulkAdd(project_bids, function(results) {
                                            if(results[0])
                                              toaster.pop('success',
                                                'Project Bids Created',
                                                'Plan data ' + results[0].plan_code + ' saved to database');
                                        });
                                    });
                                });

                                bid.project_id = saved._id;
                                bid.bid_status = 'project';
                                bid.$update();
                            });
                        });
                    });
                });
            }
        };

        var acceptRevisedBid = function(bid, trade_code, builder, totals) {
            var bid_trades = [];
            var tasks = [];
            var plan_codes = [];

            _.each(bid.plan_codes, function(plan) {
                var code = plan.code;
                var trade_totals = [];
                var total = 0;

                var items = $filter('filter')(totals, {'plan': code}, true);

                _.each(items, function(item, idx) {
                    trade_totals.push({
                        trade: item.trade,
                        total: item.total,
                        revision: (idx+1)
                    });

                    total += item.total;
                });

                plan_codes.push({
                    item: code,
                    trade_totals: trade_totals,
                    total: total
                });
            });

            if(builder) {
                var query = bid.builder_id._id ? bid.builder_id._id : bid.builder_id;

                Builders.query({'_id': query}, function(builder) {
                    if(builder.length !== 1) {
                        alert('Problem getting builder info.  Contact admin');
                        return;
                    }

                    console.log(builder[0].company_code);

                    Projects.query({'company_code': padDigits(builder[0].company_code, 3),
                        'trade_code': trade_code, 'name': bid.project_name }, function(projects) {

                        //need to check the number of projects returned and
                        //provide a dialog so the user can choose for us.
                        if(projects.length !== 1) {
                            toaster.pop('error', 'Project Query', 'Problem getting the project');
                            return;
                        }

                        var end_revision = true;

                        _.each(bid.bidding_trades, function(bidder) {
                            if(bidder.in_revision === true && bidder.submitted === true) {
                                var trade_info = $filter('filter')(projects[0].trades,
                                    {'name': bidder.trade}, true);
                                if(trade_info.length !== 1) {
                                    toaster.pop('error', 'bid-service, line 612',
                                        'Could not get trade info from project');
                                    return;
                                }

                                var index = bidder.revisions.length - 1;

                                trade_info[0].revisions.push({
                                    number: bidder.revisions.length,
                                    inclusions: bidder.revisions[index].inclusions,
                                    exclusions: bidder.revisions[index].exclusions,
                                    company_factors: bidder.revisions[index].costs,
                                });

                                trade_info[0].company_factors = bidder.costs;
                                trade_info[0].inclusions = bidder.inclusions;
                                trade_info[0].exclusions = bidder.exclusions;

                                TradeBids.query({'_id': bidder._id}, function(tb) {
                                    if(tb.length !== 1) {
                                        toaster.pop('error', 'bid-service, line: 634',
                                            'Problem getting trade bid. Contact Admin');
                                    } else {
                                        tb[0].in_revision = false;
                                        tb[0].accepted = true;
                                        //tb[0].$update(); 
                                    }
                                });

                                //get current project bids and update the latest variable
                                ProjectBids.query({'project_id': projects[0]._id,
                                    'trade': bidder.trade}, function(bids) {
                                    bids.forEach(function(bid) {
                                        if(bid.latest) {
                                            bid.latest = false;
                                            bid.revision = bidder.revisions.length;
                                            //bid.$update();
                                        }
                                    });
                                });

                                _.each(projects[0].plan_codes, function(plan) {
                                    var tasks = $filter('filter')(bidder.bid, {plan_code: plan.item}, true);

                                    var project_bids = [];
                                    _.each(tasks, function(task) {
                                        var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true);
                                        if(cp_task.length !== 1)
                                            alert('There is an issue getting the task');

                                        _.each(task.subtasks, function(sub, ij) {
                                            sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
                                            sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
                                            sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
                                            sub.unit = cp_task[0].subtasks[ij].unit;

                                            _.each(sub.materials, function(mat, jj) {
                                                mat.supplier = cp_task[0].subtasks[ij].materials[jj].supplier;
                                            });

                                            _.each(sub.equipment, function(eq, jj) {
                                                eq.supplier = cp_task[0].subtasks[ij].equipment[jj].supplier;
                                            });
                                        });
                                    });
                                    //before applying the calcs, get the piece rates and stuff from the task list
                                    //$scope.applayCalculations(tasks);
                                    taskTotalsService.getCalculations(tasks, bidder.costs);

                                    //now we have all the calculations for a given plan, so lets save them
                                    //off into the projectBids database
                                    _.each(tasks, function(task, itr) {
                                        var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true)[0];
                                        if(!cp_task) {
                                            toaster.pop('error', 'bid-service line: 685',
                                             'Could not get the task from the bid.task_list.  Call admin.');
                                            return;
                                        }
                                        var sub_arr = [];
                                        var mat_arr = [];
                                        var eq_arr = [];

                                        //build the subtask array
                                        _.each(task.subtasks, function(sub, i) {
                                            sub_arr.push({
                                                task_id: sub.task_id,
                                                name: cp_task.subtasks[i].name,
                                                crew_rate: sub.crew_rate,
                                                current_net_pay: sub.current_net_pay,
                                                employee_benefits: sub.employee_benefits,
                                                piece_per_hour_rate: sub.piece_per_hour_rate,
                                                piece_rate: sub.piece_rate,
                                                unit: sub.unit,
                                                bid_hours: sub.bid_hours,
                                                hours_allowed: sub.hours_allowed,
                                                training_and_education: sub.training_and_education,
                                                quantity: sub.quantity,
                                                labor_total: sub.labor,
                                                bid_mark_up: sub.bid_mark_up,
                                                general_liability: sub.general_liability,
                                                material_total: sub.material_total,
                                                materials_subtotal: sub.materials_subtotal,
                                                materials_dev_subtotal: sub.materials_dev_subtotal,
                                                equipment_total: sub.equipment_total,
                                                equipment_subtotal: sub.equipment_subtotal,
                                                equipment_dev_subtotal: sub.equipment_dev_subtotal,
                                                total: sub.total,
                                                work_comp: sub.work_comp
                                            });

                                            _.each(sub.materials, function(mat, j) {
                                                mat_arr.push({
                                                    name: cp_task.subtasks[i].materials[j].name,
                                                    material_id: mat.material_id,
                                                    materials_subtotal: mat.materials_subtotal,
                                                    materials_dev_subtotal: mat.materials_dev_subtotal,
                                                    supplier: mat.supplier,
                                                    quantity: mat.quantity,
                                                    price_per_order: mat.price_per_order,
                                                    piece_per_size: mat.piece_per_size,
                                                    delivery_price: mat.delivery_price,
                                                    isInventory: mat.isInventory || false,
                                                    delivery_offset: cp_task.subtasks[i].materials[j].delivery_offset,
                                                    description: cp_task.subtasks[i].materials[j].description,
                                                    note: cp_task.subtasks[i].materials[j].note,
                                                    unit: cp_task.subtasks[i].materials[j].unit
                                                });
                                            });

                                            _.each(sub.equipment, function(eq, j) {
                                                eq_arr.push({
                                                    name: cp_task.subtasks[i].equipment[j].name,
                                                    equipment_id: eq.equipment_id,
                                                    equipment_subtotal: eq.equipment_subtotal,
                                                    equipment_dev_subtotal: eq.equipment_dev_subtotal,
                                                    supplier: eq.supplier,
                                                    quantity: eq.quantity,
                                                    price_per_order: eq.price_per_order,
                                                    piece_per_size: eq.piece_per_size,
                                                    delivery_price: eq.delivery_price,
                                                    delivery_offset: cp_task.subtasks[i].equipment[j].delivery_offset,
                                                    note: cp_task.subtasks[i].equipment[j].note,
                                                    description: cp_task.subtasks[i].equipment[j].description,
                                                    unit: cp_task.subtasks[i].equipment[j].unit
                                                });
                                            });
                                        });

                                        var override = $filter('filter')(bidder.overrides, {
                                            'plan_code': task.plan_code, 'enabled': true }, true);

                                        var offset_total = 0;
                                        var mark_up = task.bid_mark_up
                                        //only adjust override total on the first task
                                        if(override.length === 1 && itr === 0) {
                                            offset_total = override[0].amount - override[0].original_amount;
                                            mark_up = override[0].amount;
                                        }

                                        var extra_liability = $filter('filter')(bidder.extra_liability, {
                                            'plan_code': task.plan_code, 'enabled': true }, true);

                                        if(extra_liability.length === 1 && itr === 0) {
                                            task.bid_general_liability += extra_liability[0].amount;
                                            task.total += extra_liability[0].amount;
                                        }

                                        var proBid = new ProjectBids({
                                            task_name: cp_task.name,
                                            trade: tradeCodeService.getName(cp_task.trade),
                                            project_id: projects[0]._id,
                                            task_code: cp_task.trade + cp_task.task,
                                            plan_code: task.plan_code,
                                            days: 1.0,
                                            hours: 8.0,
                                            latest: true,
                                            days_offset: task.task_id - 1,
                                            task_id: task.task_id,
                                            totals: {  //task totals computed during bid phase (during accepting)
                                                total: task.total + offset_total,
                                                labor: task.total_labor,
                                                materials: task.total_materials,
                                                materials_subtotal: task.materials_subtotal,
                                                materials_dev_subtotal: task.materials_dev_subtotal,
                                                equipment: task.total_equipment,
                                                equipment_subtotal: task.equipment_subtotal,
                                                equipment_dev_subtotal: task.equipment_dev_subtotal,
                                                current_net_pay: task.total_current_net_pay,
                                                general_liability: task.bid_general_liability,
                                                mark_up: mark_up,
                                                work_comp: task.work_comp,
                                                hours_allowed: task.total_hours_allowed
                                            },
                                            subtasks: sub_arr,
                                            materials: mat_arr,
                                            equipment: eq_arr
                                        });

                                        project_bids.push(proBid);
                                    });

                                    plan.trade_totals.push({
                                        'trade': bidder.trade,
                                        'revision': plan.trade_totals.length,
                                        'total': tasks.bid_total
                                    });

                                    // ProjectBids.bulkAdd(project_bids, function(results) {
                                    //     if(results[0])
                                    //       toaster.pop('success',
                                    //         'Project Bids Created',
                                    //         'Plan data ' + results[0].plan_code + ' saved to database');
                                    // });

                                    // projects[0].$update();
                                });
                            }
                            else if(bidder.in_revision === true && bidder.submitted === false) {
                                end_revision = false;
                            }
                        });

                        if(end_revision) {
                            bid.bid_status = 'project';
                            bid.in_bidder_revision = false;
                        }

                        //bid.$update();
                    });
                });
            } else {
                Trades.query({'_id': bid.trade_id._id}, function(builder) {
                    if(builder.length !== 1) {
                        toaster.pop('error', 'bid-service line 799',
                            'Problem getting builder info.  Contact admin');
                        return;
                    }

                    console.log(builder[0].company_code);

                    Projects.query({'company_code': padDigits(builder[0].company_code, 3),
                        'trade_code': trade_code, 'name': bid.project_name }, function(projects) {

                        //need to check the number of projects returned and
                        //provide a dialog so the user can choose for us.
                        if(projects.length === 0) {
                            toaster.pop('error', 'Project Query', 'Could not find a project');
                            return;
                        } else if(projects.length > 1) {
                            if(bid.project_id) {
                                var found = $filter('filter')(projects, {'_id': bid.project_id}, true);

                                if(found.length !== 1) {
                                    toaster.pop('error', 'Project Query',
                                        'Could not determine the project');
                                    return;
                                } else {
                                    projects = found;
                                }
                            } else {
                                toaster.pop('error', 'Project Query', 'No bid.project.id information');
                                return;
                            }
                        }

                        //projects[0].plan_cods has T&M
                        var plan_codes_added = projects[0].plan_codes.length != (plan_codes.length+1);
                        var new_plan_codes = [];
                        if(plan_codes_added) {
                            _.each(plan_codes, function(plan) {
                                var inlist = $filter('filter')(projects[0].plan_codes, {
                                    'item': plan.item}, true);

                                if(inlist.length === 0) {
                                    new_plan_codes.push(plan.item);
                                }
                            })
                            console.log('updating the plan codes');
                            console.log(new_plan_codes);
                            projects[0].plan_codes = plan_codes;
                            projects[0].plan_codes.push({
                                item: 'T&M',
                                trade_totals: []
                            });
                         }

                        _.each(bid.bidding_trades, function(bidder) {
                            if(bidder.in_revision === true) {
                                var trade_info = $filter('filter')(projects[0].trades,
                                    {'name': bidder.trade}, true);
                                if(trade_info.length !== 1) {
                                    toaster.pop('error', 'bid-service, line 822',
                                        'Could not get trade info from project');
                                    return;
                                }

                                //this section updates the project revision information
                                var index = bidder.revisions.length - 1;

                                trade_info[0].revisions.push({
                                    number: bidder.revisions.length,
                                    inclusions: bidder.revisions[index].inclusions,
                                    exclusions: bidder.revisions[index].exclusions,
                                    company_factors: bidder.revisions[index].costs,
                                });

                                trade_info[0].company_factors = bidder.costs;
                                trade_info[0].inclusions = bidder.inclusions;
                                trade_info[0].exclusions = bidder.exclusions;

                                TradeBids.query({'_id': bidder._id}, function(tb) {
                                    if(tb.length !== 1) {
                                        toaster.pop('error', 'bid-service, line: 843',
                                            'Problem getting trade bid. Contact Admin');
                                    } else {
                                        tb[0].in_revision = false;
                                        tb[0].accepted = true;
                                        tb[0].$update();
                                    }
                                });

                                if(new_plan_codes.length == 0) {
                                    new_plan_codes = null;
                                }
                                //bulk update latest projectBids to revision #
                                ProjectBids.query({'type': 'SetRevisionLatest',
                                    'project_id': projects[0]._id,
                                    'trade': bidder.trade,
                                    'plans': new_plan_codes,
                                    'revision': bidder.revisions.length }, function(bids) {

                                    var original_project_bids = bids;

                                    var project_bids = [];
                                    _.each(projects[0].plan_codes, function(plan) {
                                        var tasks = $filter('filter')(bidder.bid, {plan_code: plan.item}, true);
                                        // var proj_bid = $filter('filter')(original_project_bids, {
                                        //     'task_id':)

                                        _.each(tasks, function(task) {
                                            var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true);
                                            if(cp_task.length !== 1)
                                                toaster.pop('error', 'bid-service line 868',
                                                    'There is an issue getting the task');

                                            // var proj_bid = $filter('filter')(original_project_bids, {
                                            //     'task_id': cp_task[0].task_id, 'plan_code': cp_task[0].plan }, true);

                                            _.each(task.subtasks, function(sub, ij) {
                                                sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
                                                sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
                                                sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
                                                sub.unit = cp_task[0].subtasks[ij].unit;

                                                _.each(sub.materials, function(mat, jj) {
                                                    mat.supplier = cp_task[0].subtasks[ij].materials[jj].supplier;
                                                });

                                                _.each(sub.equipment, function(eq, jj) {
                                                    eq.supplier = cp_task[0].subtasks[ij].equipment[jj].supplier;
                                                });
                                            });
                                        });

                                        //before applying the calcs, get the piece rates and stuff from the task list
                                        taskTotalsService.getCalculations(tasks, bidder.costs);

                                        //now we have all the calculations for a given plan, so lets save them
                                        //off into the projectBids database
                                        _.each(tasks, function(task, itr) {
                                            var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true)[0];
                                            if(!cp_task) {
                                                toaster.pop('error', 'bid-service line 895',
                                                    'Could not get the task from the bid.task_list.  Call admin.');
                                                return;
                                            }
                                            var sub_arr = [];
                                            var mat_arr = [];
                                            var eq_arr = [];

                                            //build the subtask array
                                            _.each(task.subtasks, function(sub, i) {
                                                sub_arr.push({
                                                    task_id: sub.task_id,
                                                    name: cp_task.subtasks[i].name,
                                                    crew_rate: sub.crew_rate,
                                                    current_net_pay: sub.current_net_pay,
                                                    employee_benefits: sub.employee_benefits,
                                                    piece_per_hour_rate: sub.piece_per_hour_rate,
                                                    piece_rate: sub.piece_rate,
                                                    unit: sub.unit,
                                                    bid_hours: sub.bid_hours,
                                                    hours_allowed: sub.hours_allowed,
                                                    training_and_education: sub.training_and_education,
                                                    quantity: sub.quantity,
                                                    labor_total: sub.labor,
                                                    bid_mark_up: sub.bid_mark_up,
                                                    general_liability: sub.general_liability,
                                                    material_total: sub.material_total,
                                                    materials_subtotal: sub.materials_subtotal,
                                                    materials_dev_subtotal: sub.materials_dev_subtotal,
                                                    equipment_total: sub.equipment_total,
                                                    equipment_subtotal: sub.equipment_subtotal,
                                                    equipment_dev_subtotal: sub.equipment_dev_subtotal,
                                                    total: sub.total,
                                                    work_comp: sub.work_comp
                                                });

                                                _.each(sub.materials, function(mat, j) {
                                                    mat_arr.push({
                                                        name: cp_task.subtasks[i].materials[j].name,
                                                        material_id: mat.material_id,
                                                        materials_subtotal: mat.materials_subtotal,
                                                        materials_dev_subtotal: mat.materials_dev_subtotal,
                                                        supplier: mat.supplier,
                                                        quantity: mat.quantity,
                                                        price_per_order: mat.price_per_order,
                                                        piece_per_size: mat.piece_per_size,
                                                        delivery_price: mat.delivery_price,
                                                        isInventory: mat.isInventory || false,
                                                        delivery_offset: cp_task.subtasks[i].materials[j].delivery_offset,
                                                        description: cp_task.subtasks[i].materials[j].description,
                                                        note: cp_task.subtasks[i].materials[j].note,
                                                        unit: cp_task.subtasks[i].materials[j].unit
                                                    });
                                                });

                                                _.each(sub.equipment, function(eq, j) {
                                                    var eq = sub.equipment[j];
                                                    eq_arr.push({
                                                        name: cp_task.subtasks[i].equipment[j].name,
                                                        equipment_id: eq.equipment_id,
                                                        equipment_subtotal: eq.equipment_subtotal,
                                                        equipment_dev_subtotal: eq.equipment_dev_subtotal,
                                                        supplier: eq.supplier,
                                                        quantity: eq.quantity,
                                                        price_per_order: eq.price_per_order,
                                                        piece_per_size: eq.piece_per_size,
                                                        delivery_price: eq.delivery_price,
                                                        delivery_offset: cp_task.subtasks[i].equipment[j].delivery_offset,
                                                        note: cp_task.subtasks[i].equipment[j].note,
                                                        description: cp_task.subtasks[i].equipment[j].description,
                                                        unit: cp_task.subtasks[i].equipment[j].unit
                                                    });
                                                });
                                            });

                                            var proj_bid = $filter('filter')(original_project_bids, {
                                                'task_id': cp_task._id, 'plan_code': cp_task.plan }, true);

                                            //preserve color scheme settings
                                            if(proj_bid.length === 1) {
                                                _.each(proj_bid[0].materials, function(material) {
                                                    var update = $filter('filter')(mat_arr, {
                                                        'material_id': material.material_id }, true);

                                                    if(update.length === 1) {
                                                        update[0].color_scheme = material.color_scheme;
                                                    } else if(update.length > 1) {
                                                        console.log('there is a problem updating the color scheme');
                                                    }
                                                });
                                            }

                                            var override = $filter('filter')(bidder.overrides, {
                                                'plan_code': task.plan_code, 'enabled': true }, true);

                                            var offset_total = 0;
                                            var mark_up = task.bid_mark_up
                                            //only adjust override total on the first task
                                            if(override.length === 1 && itr === 0) {
                                                offset_total = override[0].amount - override[0].original_amount;
                                                mark_up = override[0].amount;
                                            }

                                            var extra_liability = $filter('filter')(bidder.extra_liability, {
                                                'plan_code': task.plan_code, 'enabled': true }, true);

                                            if(extra_liability.length === 1 && itr === 0) {
                                                task.bid_general_liability += extra_liability[0].amount;
                                                task.total += extra_liability[0].amount;
                                            }

                                            var proBid = new ProjectBids({
                                                task_name: cp_task.name,
                                                trade: tradeCodeService.getName(cp_task.trade),
                                                project_id: projects[0]._id,
                                                task_code: cp_task.trade + cp_task.task,
                                                plan_code: task.plan_code,
                                                days: 1.0,
                                                hours: 8.0,
                                                latest: true,
                                                days_offset: task.task_id - 1,
                                                task_id: task.task_id,
                                                totals: {  //task totals computed during bid phase (during accepting)
                                                    total: task.total + offset_total,
                                                    labor: task.total_labor,
                                                    materials: task.total_materials,
                                                    materials_subtotal: task.materials_subtotal,
                                                    materials_dev_subtotal: task.materials_dev_subtotal,
                                                    equipment: task.total_equipment,
                                                    equipment_subtotal: task.equipment_subtotal,
                                                    equipment_dev_subtotal: task.equipment_dev_subtotal,
                                                    current_net_pay: task.total_current_net_pay,
                                                    general_liability: task.bid_general_liability,
                                                    mark_up: mark_up,
                                                    work_comp: task.work_comp,
                                                    hours_allowed: task.total_hours_allowed
                                                },
                                                subtasks: sub_arr,
                                                materials: mat_arr,
                                                equipment: eq_arr
                                            });

                                            project_bids.push(proBid);
                                        });

                                        var rev_zero = $filter('filter')(plan.trade_totals, {'revision': 0}, true);
                                        //no revision should have zero.  adjust.
                                        if(rev_zero.length === 1) {
                                            _.each(plan.trade_totals, function(total) {
                                                total.revision += 1;
                                            });
                                        };

                                        var plan_total = $filter('filter')(totals, {
                                            'name': bidder.name, 'plan': plan.item }, true);

                                        if(plan_total.length !== 1 && plan.item !== 'T&M') {
                                            toaster.pop('error', 'Issue Getting Plan Total', 'Contact Admin');
                                            return;
                                        }

                                        if(plan.item !== 'T&M') {
                                            plan.trade_totals.push({
                                                'trade': bidder.trade,
                                                'revision': plan.trade_totals.length+1,
                                                'total': plan_total[0].total
                                            });
                                        }
                                    });

                                    ProjectBids.bulkAdd(project_bids, function(results) {
                                        if(results[0]) {
                                            toaster.pop('success',
                                                'Project Bids Created',
                                                'Plan data saved to database');

                                            projects[0].$update(function(success) {
                                                bid.bid_status = 'project';
                                                bid.in_bidder_revision = false;
                                                bid.$update();
                                            }, function(error) {
                                                toaster.pop('error', 'Project Update Error', error);
                                            });
                                        }
                                    });
                                });
                            }
                        });
                    });
                });
            }
        };

        var acceptServiceBid = function(mainAccountId, bid, trade_code) {
            var bid_trades = [];
            var plan_codes = [];
            var tasks = [];
            var plans = [];

            console.log('in bid-service acceptBid');

            var menu = bid.project_plan;

            _.each(bid.plan_codes, function(plan) {
                var code = plan.code;
                var trade_totals = [];
                var total = 0;

                trade_totals.push({
                    trade: tradeCodeService.getName(trade_code),
                    total: total,
                    revision: 1
                });

                plan_codes.push({
                    item: code,
                    trade_totals: trade_totals,
                    total: total
                });
            });

            bid.bidding_trades.forEach(function(bidder, idx) {
                var manager_object = $filter('filter')(bid.trades, {'main_username': mainAccountId}, true);
                if(manager_object.length != 1) {
                    toaster.pop('error', 'manager info error', 'putting in junk');
                    manager_object = {
                        manager: {
                            email: "",
                            name: "",
                            phone: "",
                            username: "",
                        },
                        foreman: {
                            email: "",
                            name: "",
                            phone: "",
                            username: "",
                        }
                    }
                } else {
                    manager_object = manager_object[0];
                }

                bid_trades.push({
                    name: bidder.trade,
                    main_username: bidder.username,
                    manager: {
                        name: manager_object.manager.name,
                        username: manager_object.manager.username,
                        phone: manager_object.manager.phone,
                        email: manager_object.manager.email
                    },
                    foreman: {
                        name: manager_object.foreman.name,
                        username: manager_object.foreman.username,
                        phone: manager_object.foreman.phone,
                        email: manager_object.foreman.email
                    },
                    supplier: bidder.supplier,
                    equipment_supplier: bidder.equipment_supplier,
                    inclusions: bidder.inclusions,
                    exclusions: bidder.exclusions,
                });

                tasks = [];
                var days_off = 0;
                bidder.task_list.forEach(function(task, ii) {
                    var subs = [];
                    task.subtasks.forEach(function(sub) {
                        subs.push({
                            name: sub.name
                        });
                    });

                    tasks.push({
                        name: task.name,
                        order: task._id,
                        task: task.task,
                        hours: 8.0,
                        days: 1.0,
                        days_offset: days_off,
                        trade: task.trade,
                        subtasks: subs
                    });

                    days_off += 1;
                });

                plans.push({
                    item: 'Standard',
                    task_list: tasks
                });
            });

            var query = bid.trade_id._id ? bid.trade_id._id : bid.trade_id;

            Trades.query({'_id': query}, function(builder) {
                if(builder.length !== 1) {
                    alert('Problem getting builder info.  Contact admin');
                    return;
                }

                //the service bid does not go through bid editing or 
                //review so it will use the company's basic costs
                bid_trades[0].company_factors = {
                    payroll_taxes: builder[0].costs.payroll_taxes,
                    w_comp_high: builder[0].costs.w_comp_high,
                    w_comp_low: builder[0].costs.w_comp_low,
                    general_liability: builder[0].costs.general_liability,
                    w_comp_break: builder[0].costs.w_comp_break,
                    sales_tax: builder[0].costs.sales_tax,
                    material: builder[0].costs.material,
                    equipment: builder[0].costs.equipment,
                    labor: builder[0].costs.labor
                }

                bid.bidding_trades[0].costs = bid_trades[0].company_factors;

                console.log(builder[0].company_code);

                ProjectJobs.query({'company_code': padDigits(builder[0].company_code, 3),
                    'trade_code': trade_code}, function(jobs) {
                    var new_job_code = '';

                    if(jobs.length === 1) {
                        new_job_code = padDigits(jobs[0].current_value, 4);
                        jobs[0].current_value = jobs[0].current_value + 1;
                        if(jobs[0].current_value === 10000) jobs[0].current_value = 1;
                        jobs[0].$update();
                    } else if(jobs.length === 0) {
                        var new_job = new ProjectJobs({
                            company_code: padDigits(builder[0].company_code, 3),
                            trade_code: trade_code,
                            current_value: 2
                        });
                        new_job_code = padDigits(1, 4);
                        new_job.$save();
                    } else if(jobs.length > 1) {
                        alert('More than one contractor/division combination came back.  Call admin.');
                        return;
                    }

                    var pa = {
                        name: '',
                        email: '',
                        phone: ''
                    }

                    if(bid.purchasing_agent_info) {
                        pa = bid.purchasing_agent_info;
                    } else {
                        pa.name = bid.purchasing_agent_name;
                        pa.email = bid.purchasing_agent_email;
                        pa.phone = bid.purchasing_agent_phone;
                    }

                    var bid_builder = {
                        name: '',
                        address_one: '',
                        address_two: '',
                        city: '',
                        state: '',
                        zip: '',
                        email: '',
                        phone: ''
                    }

                    if(bid.builder_info) {
                        bid_builder = bid.builder_info;
                    } else {
                        bid_builder = builder[0];
                    }

                    var pm = {
                        name: '',
                        email: '',
                        phone: ''
                    }

                    if(bid.project_manager_info) {
                        pm = bid.project_manager_info
                    }

                    var geocoder = new google.maps.Geocoder();
                    var lat = null, lng = null;
                    geocoder.geocode( { 'address' : bid.project_address + " " + bid.city + " " + bid.state }, function( results, status ) {
                        if (status == 'OK') {
                            lat = results[0].geometry.location.lat();
                            lng = results[0].geometry.location.lng();
                        }
                        var project = new Projects({
                            name: bid.project_name,
                            projectBidId: bid._id,
                            job_code: new_job_code,
                            trade_code: trade_code,
                            company_code: padDigits(builder[0].company_code, 3),
                            contact: {
                                name: pa.name,
                                address_one: bid.project_address,
                                address_two: '',
                                city: bid.project_city,
                                state: bid.project_state,
                                zip: bid.project_zip,
                                timezone: bid.project_timezone,
                                email: pa.email,
                                phone: pa.phone,
                                lat: lat,
                                lng: lng
                            },
                            lots: [{
                                active_options: [],
                                color_scheme: "",
                                complete: false,
                                number: "001",
                                phase: "00",
                                plan: "Service",
                                reverse: "",
                                revisions: [{
                                    'revision': 1,
                                    'trade': tradeCodeService.getName(trade_code)
                                }],
                                scheduled: false,
                                start_date: new Date(bid.project_start_date)
                            }],
                            builder: {
                                name: bid_builder.name,
                                address_one: bid_builder.address_one,
                                address_two: bid_builder.address_two,
                                city: bid_builder.city,
                                state: bid_builder.state,
                                zip: bid_builder.zip,
                                email: bid_builder.email,
                                phone: bid_builder.phone
                            },
                            mtc: {
                                division_manager_name: pm.name,
                                division_manager_phone_number: pm.phone,
                                division_manager_email: pm.email
                            },
                            project_type: bid.project_type,
                            projectType: bid.projectType,
                            geoLocation: bid.geoLocation,
                            plan_codes: plan_codes,
                            trades: bid_trades,
                            plan: plans,
                            mainAccountId: mainAccountId
                        });

                        project.$save(function(saved) {
                            console.log('project save came back with ' + saved._id);
                            if(optionSaveService.updateProjectIdFromBidId(bid._id, saved._id)) {
                                return;
                            }

                            _.each(bid.bidding_trades, function(bidder) {
                                _.each(saved.plan_codes, function(plan) {
                                    var tasks = $filter('filter')(bidder.bid, {plan_code: plan.item}, true);

                                    var project_bids = [];
                                    _.each(tasks, function(task) {
                                        var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true);
                                        if(cp_task.length !== 1)
                                            alert('There is an issue getting the task');

                                        _.each(task.subtasks, function(sub, ij) {
                                            sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
                                            sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
                                            sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
                                            sub.unit = cp_task[0].subtasks[ij].unit;

                                            _.each(sub.materials, function(mat, jj) {
                                                mat.supplier = cp_task[0].subtasks[ij].materials[jj].supplier;
                                            });

                                            _.each(sub.equipment, function(eq, jj) {
                                                eq.supplier = cp_task[0].subtasks[ij].equipment[jj].supplier;
                                            });
                                        });
                                    });
                                    //before applying the calcs, get the piece rates and stuff from the task list
                                    //$scope.applayCalculations(tasks);
                                    taskTotalsService.getCalculations(tasks, builder[0].costs);

                                    //now we have all the calculations for a given plan, so lets save them
                                    //off into the projectBids database
                                    _.each(tasks, function(task, itr) {
                                        var cp_task = $filter('filter')(bidder.task_list, {_id: task.task_id}, true)[0];
                                        if(!cp_task) {
                                            alert('Could not get the task from the bid.task_list.  Call admin.');
                                            return;
                                        }
                                        var sub_arr = [];
                                        var mat_arr = [];
                                        var eq_arr = [];

                                        //build the subtask array
                                        _.each(task.subtasks, function(sub, i) {
                                            sub_arr.push({
                                                task_id: sub.task_id,
                                                name: cp_task.subtasks[i].name,
                                                crew_rate: sub.crew_rate,
                                                current_net_pay: sub.current_net_pay,
                                                employee_benefits: sub.employee_benefits,
                                                piece_per_hour_rate: sub.piece_per_hour_rate,
                                                piece_rate: sub.piece_rate,
                                                unit: sub.unit,
                                                bid_hours: sub.bid_hours,
                                                hours_allowed: sub.hours_allowed,
                                                training_and_education: sub.training_and_education,
                                                quantity: sub.quantity,
                                                labor_total: sub.labor,
                                                bid_mark_up: sub.bid_mark_up,
                                                general_liability: sub.general_liability,
                                                material_total: sub.material_total,
                                                materials_subtotal: sub.materials_subtotal,
                                                materials_dev_subtotal: sub.materials_dev_subtotal,
                                                equipment_total: sub.equipment_total,
                                                equipment_subtotal: sub.equipment_subtotal,
                                                equipment_dev_subtotal: sub.equipment_dev_subtotal,
                                                total: sub.total,
                                                work_comp: sub.work_comp
                                            });

                                            _.each(sub.materials, function(mat, j) {
                                                mat_arr.push({
                                                    name: cp_task.subtasks[i].materials[j].name,
                                                    material_id: mat.material_id,
                                                    materials_subtotal: mat.materials_subtotal,
                                                    materials_dev_subtotal: mat.materials_dev_subtotal,
                                                    supplier: mat.supplier,
                                                    quantity: mat.quantity,
                                                    price_per_order: mat.price_per_order,
                                                    piece_per_size: mat.piece_per_size,
                                                    delivery_price: mat.delivery_price,
                                                    isInventory: mat.isInventory || false,
                                                    delivery_offset: cp_task.subtasks[i].materials[j].delivery_offset,
                                                    description: cp_task.subtasks[i].materials[j].description,
                                                    note: cp_task.subtasks[i].materials[j].note,
                                                    unit: cp_task.subtasks[i].materials[j].unit
                                                });
                                            });

                                            _.each(sub.equipment, function(eq, j) {
                                                eq_arr.push({
                                                    name: cp_task.subtasks[i].equipment[j].name,
                                                    equipment_id: eq.equipment_id,
                                                    equipment_subtotal: eq.equipment_subtotal,
                                                    equipment_dev_subtotal: eq.equipment_dev_subtotal,
                                                    supplier: eq.supplier,
                                                    quantity: eq.quantity,
                                                    price_per_order: eq.price_per_order,
                                                    piece_per_size: eq.piece_per_size,
                                                    delivery_price: eq.delivery_price,
                                                    delivery_offset: cp_task.subtasks[i].equipment[j].delivery_offset,
                                                    note: cp_task.subtasks[i].equipment[j].note,
                                                    unit: cp_task.subtasks[i].equipment[j].unit,
                                                    description: cp_task.subtasks[i].equipment[j].description
                                                });
                                            });
                                        });

                                        var override = $filter('filter')(bidder.overrides, {
                                            'plan_code': task.plan_code, 'enabled': true }, true);

                                        var offset_total = 0;
                                        var mark_up = task.bid_mark_up
                                        //only adjust override total on the first task
                                        if(override.length === 1 && itr === 0) {
                                            offset_total = override[0].amount - override[0].original_amount;
                                            mark_up = override[0].amount;
                                        }

                                        var extra_liability = $filter('filter')(bidder.extra_liability, {
                                            'plan_code': task.plan_code, 'enabled': true }, true);

                                        if(extra_liability.length === 1 && itr === 0) {
                                            task.bid_general_liability += extra_liability[0].amount;
                                            task.total += extra_liability[0].amount;
                                        }

                                        var proBid = new ProjectBids({
                                            task_name: cp_task.name,
                                            trade: tradeCodeService.getName(cp_task.trade),
                                            project_id: saved._id,
                                            task_code: cp_task.trade + cp_task.task,
                                            plan_code: task.plan_code,
                                            days: 1.0,
                                            hours: 8.0,
                                            days_offset: task.task_id - 1,
                                            task_id: task.task_id,
                                            totals: {  //task totals computed during bid phase (during accepting)
                                                total: task.total + offset_total,
                                                labor: task.total_labor,
                                                materials: task.total_materials,
                                                materials_subtotal: task.materials_subtotal,
                                                materials_dev_subtotal: task.materials_dev_subtotal,
                                                equipment: task.total_equipment,
                                                equipment_subtotal: task.equipment_subtotal,
                                                equipment_dev_subtotal: task.equipment_dev_subtotal,
                                                current_net_pay: task.total_current_net_pay,
                                                general_liability: task.bid_general_liability,
                                                mark_up: mark_up,
                                                work_comp: task.work_comp,
                                                hours_allowed: task.total_hours_allowed
                                            },
                                            subtasks: sub_arr,
                                            materials: mat_arr,
                                            equipment: eq_arr
                                        });

                                        project_bids.push(proBid);
                                    });

                                    console.log(project_bids);
                                    ProjectBids.bulkAdd(project_bids, function(results) {
                                        console.log(results);
                                        if(results[0])
                                          toaster.pop('success',
                                            'Project Bids Created',
                                            'Plan data ' + results[0].plan_code + ' saved to database');
                                    });
                                });
                            });

                            bid.project_id = saved._id;
                            bid.bid_status = 'project';
                            bid.$update();
                        });
                    });
                });
            });
        };

        return {
            attachTaskList: attachTaskList,
            acceptBid: acceptBid,
            acceptRevisedBid: acceptRevisedBid,
            acceptServiceBid: acceptServiceBid
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/services/bid-service.js